<script lang="ts">
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const { GOOGLE_ANALYTICS } = getGlobalSettings();

	/* eslint-disable */
</script>

<svelte:head>
	<script async src="https://www.googletagmanager.com/gtag/js?id={GOOGLE_ANALYTICS}"></script>
	{@html `
	<script>
		window.dataLayer ||= [];
		function gtag(){window.dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', '${GOOGLE_ANALYTICS}');
	</script>
	`}
</svelte:head>
